function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassHeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 140 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-51.6663,-3700.09)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.794927,0,0,0.794927,33.4097,768.072)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112.855,
    cy: 3776.47,
    r: 63.094,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "8.81px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Needle",
    style: {
      transformBox: "fill-box",
      transformOrigin: "center"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3.22958,-2.84217e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.596,3726.91L123.121,3770.09L114.071,3770.09L118.596,3726.91Z",
    style: {
      fill: "var(--chakra-colors-brand-200)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.22465e-16,-1.22465e-16,-1,240.422,7540.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.596,3726.91L123.121,3770.09L114.071,3770.09L118.596,3726.91Z",
    style: {
      fill: "rgb(215,216,214)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ordinals"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tooltip-Top",
    serifid: "Tooltip Top",
    transform: "matrix(1.27689,0,0,1.2442,122.198,3712.47)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "-5.055px",
    y: "0px",
    style: {
      fontFamily: "'Helvetica'",
      fontSize: 14
    }
  }, "N")), /*#__PURE__*/React.createElement("g", {
    id: "Tooltip-Top1",
    serifid: "Tooltip Top",
    transform: "matrix(1.27689,0,0,1.2442,186.495,3776.77)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "-4.669px",
    y: "0px",
    style: {
      fontFamily: "'Helvetica'",
      fontSize: 14
    }
  }, "E")), /*#__PURE__*/React.createElement("g", {
    id: "Tooltip-Top2",
    serifid: "Tooltip Top",
    transform: "matrix(1.27689,0,0,1.2442,122.198,3843.7)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "-4.669px",
    y: "0px",
    style: {
      fontFamily: "'Helvetica'",
      fontSize: 14
    }
  }, "S")), /*#__PURE__*/React.createElement("g", {
    id: "Tooltip-Top3",
    serifid: "Tooltip Top",
    transform: "matrix(1.27689,0,0,1.2442,59.1774,3776.29)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "-6.607px",
    y: "0px",
    style: {
      fontFamily: "'Helvetica'",
      fontSize: 14
    }
  }, "W")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassHeading);
export default __webpack_public_path__ + "static/media/compass-heading.7c24419fd82721aa0394f29f5ecfa741.svg";
export { ForwardRef as ReactComponent };